import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

const CarteiraRFRow = (props) => {
    return (
        <li className="list-group-item list-group-item-action flex-column align-items-start">
            <div className="row">
                <div className="col-12 col-md-11">
                    <div className="d-flex w-100 justify-content-between">
                        <h4>{props.ativo}</h4>
                        <h4>{(parseFloat(props.percentualTotal) * 100).toFixed(2)}%</h4>
                    </div>
                    <div className="d-flex w-100 justify-content-between">
                        <small>{parseFloat(props.precoMedioReal).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</small>
                        <small>{(parseFloat(props.peso) * 100).toFixed(2)}%</small>
                        <small>{parseFloat(props.ultimaCotacao).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</small>
                    </div>
                </div>
                <div className="col col-md-1">
                    <Link to={`/rfixas/${props.ativo_id}`}>
                        <i className="fas fa-shopping-cart" style={{ cursor: "pointer" }} />
                    </Link>
                </div>
            </div>
        </li>
    );
};

CarteiraRFRow.propTypes = {
    ativo: PropTypes.string.isRequired,
    ativo_id: PropTypes.number.isRequired,
    qtdCustodia: PropTypes.number.isRequired,
    percentualTotal: PropTypes.number.isRequired,
    precoMedioReal: PropTypes.number.isRequired,
    ultimaCotacao: PropTypes.string.isRequired,
    peso: PropTypes.number.isRequired,
    pesoMeta: PropTypes.number.isRequired,
    diferencaValor: PropTypes.number.isRequired,
};

export default CarteiraRFRow;


// WEBPACK FOOTER //
// ./src/components/carteira/CarteiraRFRow.js